const zscqArr = [
  { id: 1, label: '发明专利' },
  { id: 2, label: '外观专利' },
  { id: 3, label: '实用新型专利' },
  { id: 4, label: 'PCT国际专利' },
  { id: 5, label: '工法' },
  { id: 6, label: '软著' }
]

const rzArr = [
  { id: 1, label: '国际标准' },
  { id: 2, label: '国家标准' },
  { id: 3, label: '行业标准' },
  { id: 4, label: '地方标准' },
  { id: 5, label: '团体标准' },
  { id: 6, label: '企业标准' }
]

export { zscqArr, rzArr }
